import React from 'react'
import Head from 'components/Head'
import SiteLayout from 'components/SiteLayout'
import BrandDetailAbout from 'components/Brands/BrandDetailAbout'
import { BrandsStore } from 'stores/brands'
import { usePageView, useStore } from 'hooks'
import { getStaticWrapper } from 'utils'

const BrandDetailAboutPage = ({ brand }) => {
  useStore(BrandsStore, { current: brand })

  usePageView(undefined, [brand.id])

  return (
    <SiteLayout>
      <Head
        title={`${brand.name} | Blogs, Podcasts and Videos | Barstool Sports`}
        description={`Get all of the latest ${brand.name} blogs, videos and podcasts.`}
        ogImage={`${brand.cover_photo}?crop=1200:630,smart`}
        canonical={`${process.env.SITE_URL}/shows/${brand.id}/${brand.slug}/about`}
      />
      <BrandDetailAbout />
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper(async ({ params }) => {
  const { id } = params
  const brand = await BrandsStore().readWithVideo(id)
  return {
    brand
  }
})

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export default BrandDetailAboutPage
